import React, { useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { dateIsBefore, daysAreSame, formatDate } from '../../utils/helpers'
import useAnnouncements from '../../hooks/announcements/useAnnouncements'
import { useStore } from '../../hooks/globals/useStore'
import shallow from 'zustand/shallow'

const Sidebar = () => {
  const { data: announcements, isSuccess: announcementsSuccess } = useAnnouncements()

  const { adminItem, changeAdminItem } = useStore((state) => ({
    adminItem: state.adminItem,
    changeAdminItem: state.changeAdminItem
  }), shallow)

  const navigate = useNavigate()
  const location = useLocation()

  const handleChangeMenuItem = (event) => {
    changeAdminItem(event.target.value)
    navigate(event.target.value)
  }
  
  useEffect(() => {
    const path = location.pathname.split('/')
    changeAdminItem(`/${path[1] === 'kpi' ? '' : path[1]}`)
  }, [])

  return (
    <div id='sidebar'>
      <Typography
        sx={{
          typography: { lg: 'h4', md: 'h5' },
          fontWeight: 'bold'
        }}
        style={{ fontWeight: 'bold' }}
      >
      Links
      </Typography>
      <Typography
        component='a'
        href='https://novir-usa.com'
        sx={{ 
          mt: 1,
          typography: { lg: 'h5', md: 'h6' }, 
        }}
      >
      Novir-usa.com
      </Typography>
      <Typography
        component='a'
        href='#'
        sx={{
          typography: { lg: 'h5', md: 'h6' }, 
        }}
      >
      Time Tracking
      </Typography>
      <Typography
        component='a'
        href='#'
        sx={{
          typography: { lg: 'h5', md: 'h6' }, 
        }}
      >
      401k
      </Typography>
      <Typography
        component='a'
        href='#'
        sx={{
          typography: { lg: 'h5', md: 'h6' }, 
        }}
      >
      Healthcare
      </Typography>
      {
        announcementsSuccess && (
          <>
            <Typography
              sx={{
                typography: { lg: 'h4', md: 'h5' },
                mt: 3
              }}
              style={{ fontWeight: 'bold' }}
            >
        Announcements
            </Typography>
            {
              announcements.filter((announcement) => dateIsBefore(new Date(), new Date(announcement.EndDate)) || daysAreSame(new Date(), new Date(announcement.EndDate)))
                .map((announcement) => (
                  <Box
                    key={`announcement_${announcement.Id}`}
                    component='div'
                  >
                    <Typography
                      component={Link}
                      to={`/announcements/${announcement.Id}`}
                      sx={{
                        typography: { lg: 'h5', md: 'h6' }, 
                      }}
                    >
                      {announcement.Title}
                    </Typography>
                    <Typography>{formatDate(new Date(announcement.EndDate))}</Typography>
                  </Box>
                ))
            }
          </>
        )
      }
      <Typography
        sx={{
          typography: { lg: 'h4', md: 'h5' },
          fontWeight: 'bold',
          mt: 2
        }}
        style={{ fontWeight: 'bold' }}
      >
      Admin Menu
      </Typography>
      <FormControl fullWidth>
        <Select
          labelId="menu-label"
          id="menu-select"
          value={adminItem}
          onChange={handleChangeMenuItem}
        >
          <MenuItem value='/'>Home</MenuItem>
          <MenuItem value='/announcements'>Announcements</MenuItem>
          <MenuItem value='/reports'>Reports</MenuItem>
          <MenuItem value='/users'>Users</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default Sidebar